import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, of, pipe, switchMap, tap } from 'rxjs';
import { ErrorResponse, LoginResponse } from '../../../shared/models/app.model';
import { AuthService } from '../../../shared/services/auth.service';
import { LoginModel } from '../models/login.model';

type LoginState = {
  token: string | null;
  error: ErrorResponse | null;
  loginSuccess: boolean;
};

export const LoginStore = signalStore(
  { providedIn: 'root' },
  withState<LoginState>({ token: null, error: null, loginSuccess: false }),
  withMethods((store, authService = inject(AuthService)) => ({
    login: rxMethod<LoginModel>(
      pipe(
        switchMap(payload =>
          authService.login(payload).pipe(
            tap((res: { data: LoginResponse }) => {
              authService.setToken(res.data);
              patchState(store, { token: res.data.token, loginSuccess: true, error: null });
            }),
            catchError(err => {
              patchState(store, { error: err, loginSuccess: false });
              return of(null);
            })
          )
        )
      )
    ),
    reset(): void {
      patchState(store, { loginSuccess: false, error: null });
    }
  }))
);
